import React, { useEffect, useState } from 'react';
import {
  DownOutlined,
  FolderOpenFilled,
  RightOutlined,
} from "@ant-design/icons";
import { Spin,Tooltip } from "antd";
import { ReactComponent as ModuleIcon } from "../../../assets/images/reusable-items/module.svg";
import { ReactComponent as CourseIcon } from "../../../assets/images/reusable-items/course.svg";
import Chat from '../../shared/AIChat';

const AIChat = (props: any) => {
  const {
    modules,
    courses,
    loading,
    loaded,
    coursesLoading,
    coursesLoaded,
    lessonSummary,
    lessonSummaryLoading,
    actions: { getModule, getCourse, getLessonSummary },
  } = props;

  const [expandedModules, setExpandedModules] = useState<number[]>([]);
  const [expandedCourses, setExpandedCourses] = useState<number[]>([]);
  const [selectedLesson, setSelectedLesson] = useState<any | null>(null);

  useEffect(() => {
    if (!loaded) getModule();
  }, [loaded]);

  useEffect(() => {
    if (!coursesLoaded) getCourse();
  }, [coursesLoaded]);

  const toggleModule = (moduleId: number) => {
    setExpandedModules(prev =>
      prev.includes(moduleId)
        ? prev.filter(id => id !== moduleId)
        : [...prev, moduleId]
    );
  };

  const toggleCourse = (courseId: number) => {
    setExpandedCourses(prev =>
      prev.includes(courseId)
        ? prev.filter(id => id !== courseId)
        : [...prev, courseId]
    );
  };

  const selectLesson = (lesson: any) => {
    setSelectedLesson(lesson);
    getLessonSummary({id:lesson.id});
  };

  return (
    <div className="flex h-full">
      {/* Left Sidebar */}
      <div className="w-80 border-r border-gray-200 overflow-y-auto">
        <div className="pr-4">
          <h1 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
            <FolderOpenFilled className="w-5 h-5" />
            Learning Path
          </h1>

          {(loading || coursesLoading) ? (
            <div className="flex justify-center py-10">
              <Spin tip="Loading modules and courses..." />
            </div>
          ) : (
            <div className="space-y-2">
              {modules.map((module: any) => (
                <div key={module.id} className="rounded-lg overflow-hidden">
                  {/* Module Header */}
                  <button
                    className="w-full flex items-center justify-between p-3 text-left bg-gray-50 hover:bg-gray-100 transition-colors"
                    onClick={() => toggleModule(module.id)}
                  >
                    <div className="flex items-center gap-2">
                      <ModuleIcon className="w-4 h-4 fill-primary-500" />
                      <span className="font-medium text-gray-700">{module.title}</span>
                    </div>
                    {expandedModules.includes(module.id) ? (
                      <DownOutlined className="w-4 h-4 text-gray-500" />
                    ) : (
                      <RightOutlined className="w-4 h-4 text-gray-500" />
                    )}
                  </button>

                  {/* Courses within Module */}
                  {expandedModules.includes(module.id) && (
                    <div className="bg-neutral-50 pl-4">
                      {module.courses.map((course: any) => (
                        <div key={course.id}>
                          <button
                            className="w-full flex items-center justify-between p-3 text-left hover:bg-gray-100 transition-colors"
                            onClick={() => toggleCourse(course.id)}
                          >
                            <div className="flex items-center gap-2">
                              <CourseIcon className="w-4 h-4 fill-primary-400" />
                              <span className="text-gray-700">{course.title}</span>
                            </div>
                            {expandedCourses.includes(course.id) ? (
                              <DownOutlined className="w-4 h-4 text-gray-500" />
                            ) : (
                              <RightOutlined className="w-4 h-4 text-gray-500" />
                            )}
                          </button>

                          {expandedCourses.includes(course.id) && (
                  <div className="bg-gray-50 px-4">
                    {course.lessons.map((lesson: any) => (
                      <Tooltip
                        key={lesson.id}
                        title={
                          lesson.videoUri === null
                            ? "This lesson does not have a video."
                            : ""
                        }
                      >
                        <button
                          className={`w-full p-3 pl-6 mb-2 rounded-md text-left transition-colors ${
                            lesson.videoUri === null
                              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                              : selectedLesson?.id === lesson.id
                              ? "bg-blue-50 text-blue-600"
                              : "hover:bg-gray-100 text-gray-600"
                          }`}
                          disabled={lesson.videoUri === null}
                          onClick={() => selectLesson(lesson)}
                        >
                          {lesson.title}
                        </button>
                      </Tooltip>
                    ))}
                  </div>
                )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}

              {/* Standalone courses (ako postoje) */}
              {courses.map((course: any) => (
                <div key={course.id} className="rounded-lg overflow-hidden">
                  <button
                    className="w-full flex items-center justify-between p-3 text-left bg-gray-50 hover:bg-gray-100 transition-colors"
                    onClick={() => toggleCourse(course.id)}
                  >
                    <div className="flex items-center gap-2">
                      <CourseIcon className="w-4 h-4 fill-primary-400" />
                      <span className="text-gray-700">{course.title}</span>
                    </div>
                    {expandedCourses.includes(course.id) ? (
                      <DownOutlined className="w-4 h-4 text-gray-500" />
                    ) : (
                      <RightOutlined className="w-4 h-4 text-gray-500" />
                    )}
                  </button>

                  {expandedCourses.includes(course.id) && (
                  <div className="bg-gray-50 px-4">
                    {course.lessons.map((lesson: any) => (
                      <Tooltip
                        key={lesson.id}
                        title={
                          lesson.videoUri === null
                            ? "This lesson does not have a video."
                            : ""
                        }
                      >
                        <button
                          className={`w-full p-3 pl-6 mb-2 rounded-md text-left transition-colors ${
                            lesson.videoUri === null
                              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                              : selectedLesson?.id === lesson.id
                              ? "bg-blue-50 text-blue-600"
                              : "hover:bg-gray-100 text-gray-600"
                          }`}
                          disabled={lesson.videoUri === null}
                          onClick={() => selectLesson(lesson)}
                        >
                          {lesson.title}
                        </button>
                      </Tooltip>
                    ))}
                  </div>
                )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Right Chat Area */}
      <div className="flex-1 flex flex-col pl-5">
        {selectedLesson ? (
          lessonSummaryLoading ? (
            <div className="flex-1 flex items-center justify-center">
              <Spin tip="Loading lesson summary..." />
            </div>
          ) : (
            <Chat summary={lessonSummary} />
          )
        ) : (
          <div className="flex-1 flex items-center justify-center text-gray-500">
            Select a lesson to begin
          </div>
        )}
      </div>
    </div>
  );
};

export default AIChat;
